// @ts-ignore
var SvgIcons = import('../../util/svgIcons.js');
var initialState = {
    icons: SvgIcons,
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        default: {
            return state;
        }
    }
};
export { reducer as AssetReducer };
